<script setup lang="ts">
import type { SplitterResizeHandleProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { SplitterResizeHandle, useForwardProps } from 'reka-ui';
import { GripVertical } from 'lucide-vue-next';
import { cn } from '@/lib/utils';

const props = defineProps<
  SplitterResizeHandleProps & {
    class?: HTMLAttributes['class'];
  }
>();

const delegatedProps = reactiveOmit(props, 'class');
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SplitterResizeHandle
    v-bind="forwardedProps"
    :class="
      cn(
        'tw-relative tw-flex tw-w-px tw-items-center tw-justify-center tw-bg-neutral-200 after:tw-absolute after:tw-inset-y-0 after:tw-left-1/2 after:tw-w-1 after:-tw-translate-x-1/2 focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-neutral-950 focus-visible:tw-ring-offset-1 data-[panel-group-direction=vertical]:tw-h-px data-[panel-group-direction=vertical]:tw-w-full data-[panel-group-direction=vertical]:after:tw-left-0 data-[panel-group-direction=vertical]:after:tw-h-1 data-[panel-group-direction=vertical]:after:tw-w-full data-[panel-group-direction=vertical]:after:-tw-translate-y-1/2 data-[panel-group-direction=vertical]:after:tw-translate-x-0 [&[data-panel-group-direction=vertical]>div]:tw-rotate-90',
        props.class
      )
    "
  >
    <div
      class="tw-z-10 tw-flex tw-h-4 tw-w-3 tw-items-center tw-justify-center tw-rounded-sm tw-border tw-border-neutral-200 tw-bg-neutral-100"
    >
      <GripVertical class="tw-h-2.5 tw-w-2.5" />
    </div>
  </SplitterResizeHandle>
</template>
